import React from 'react';
import styled from 'styled-components/macro';
import Placeholder from '@tovia/man-ui/lib/components/Placeholder/Placeholder';

export const GalleryCardPlaceholder = () => {
  const { Image } = Placeholder;

  return (
    <GalleryCard>
      <Image />
    </GalleryCard>
  );
};

const GalleryCard = styled(Placeholder)`
  width: 160px;
  flex-shrink: 0;
  margin: 0 5px 27px 18px;

  .image {
    height: 240px;
    padding-top: 0;
  }
`;
